angular.module("ainapp")
    .controller("whatsAppSettingsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "WhatsApp Settings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {


                $scope.ViewVal = 0;
                $scope.ViewValType = 'Purchase Request';

                $scope.CostSetting = {
                    VoucherType: "Purchase Request",
                    IsPdf: false,
                    IsEnable: true,
                    HeadDescription: "",
                    BodyDescription: "",
                }

                $scope.CostCenterSettings = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.WhatsappSettingsbyType("Purchase Request").then(function (response) {
                    $scope.CostSetting = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CostCenterSettings = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.WhatsappSettingsbyType(type).then(function (response) {
                    $scope.CostSetting = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.refreshCostCenter = function () {
                $scope.switchTab($scope.ViewVal, $scope.ViewValType);
            }

            $scope.editCostCenter = function (data) {
                $scope.CostSetting = data;
            }

            $scope.saveCostSettings = function () {

                if ($scope.CostSetting.CostCenterId == "") {
                    toastr.warnig("Choose Cost Center");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.CostSetting.VoucherType = $scope.ViewValType;
                    MainService.AddWhatsappSetting($scope.CostSetting).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                            $scope.refreshCostCenter();
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.load = false;
                    })
                }

            }




      }]);
